import React, { useState, useEffect } from "react";
import NavbarGuest from "./NavbarGuest";
import Footer from "./Footer";
import FAQquestions from "./commonTextPages/FAQquestions";

export default function FAQ() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <div className="fullScreenLayout">
      <NavbarGuest/>
        <FAQquestions/>
      <Footer/>
      </div>
    </>
  );
}
